import * as React from "react";
import { useGlobalData } from "../../contexts";
import { FGTextInput, useFGContext } from "nsitools-react";
import { ETLCodes } from "../../locales";
import { useTl } from "../../hooks";
import { Spinner } from "@blueprintjs/core";
import { getIn } from "formik";

export interface IFGMultiTranslateProps {
  translationsArrayField: string;
  translationField: string;
  label: ETLCodes;
  translationDto: any;
  maxlength?: number;
  readonly?: boolean;
  languageIdFieldName?: string;
}

interface ITranslationData {
  languageId: number;
}

export const FGMultiTranslate: React.FunctionComponent<IFGMultiTranslateProps> = ({
  translationsArrayField: listName,
  translationField: variableName,
  label,
  languageIdFieldName = "languageId",
  translationDto,
  maxlength = undefined,
  readonly = false,
}) => {
  const { languages } = useGlobalData();
  const { t } = useTl();
  const { formik, loading } = useFGContext();

  const finalData = React.useMemo(() => {
    if (formik?.values) {
      const missingLanguages = languages?.filter(
        (c) => !formik.values[listName].flatMap((cn) => getIn(cn, languageIdFieldName)).includes(c.languageId)
      );
      missingLanguages?.forEach((ml) => {
        formik.values[listName].push(new translationDto({ [languageIdFieldName]: ml.languageId }));
      });
      return formik.values;
    }
    return null;
  }, [formik, languages, listName, translationDto]);

  return loading ? (
    <Spinner />
  ) : (
    <>
      {languages?.map((value, index) => {
        formik.values = finalData;
        const nameIndex = formik.values[listName].findIndex(
          (d: ITranslationData) => getIn(d, languageIdFieldName) === value.languageId
        );
        return (
          <FGTextInput
            key={index}
            name={`${listName}[${nameIndex}].${variableName}`}
            label={`${t(label)} ${value.languageCode}`}
            maxLength={maxlength}
            readonly={readonly}
            requiredMark
          />
        );
      })}
    </>
  );
};
